import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { fetchInventoryExportUrl } from '../../sagas/routines';
import { clearInventoryExportUrl } from '../../actions';
import { setInventoryExportInProgress } from '../../actions/export';

const initialState = {
  inProgress: '',
  presignedUrl: '',
  fetching: false
};

const fetchInventoryExportUrlHandler = routine => ({
  [routine.REQUEST]: set('fetching', true),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    inProgress: '',
    presignedUrl: response.presignedUrl
  }),
  [routine.FULFILL]: set('fetching', false)
});

const clearHandler = action => ({
  [action.toString()]: set('presignedUrl', '')
});

const setInventoryExportInProgressHandler = action => ({
  [action.toString()]: (state, { payload: type }) =>
    set('inProgress', type, state)
});

export default createReducer(initialState, {
  ...fetchInventoryExportUrlHandler(fetchInventoryExportUrl),
  ...setInventoryExportInProgressHandler(setInventoryExportInProgress),
  ...clearHandler(clearInventoryExportUrl)
});
